export enum ArtifactMintSteps {
    ArtifactMintedFeedback = 'ArtifactMintedFeedback',
    Introduction = 'Introduction',
    AcceptTerms = 'AcceptTerms',
    Complete = 'Complete',
    Loading = 'Loading',
    Select = 'Select',
    Error = 'Error',
}

export enum ArtifactType {
    PrismCase = 'PrismCase',
    PrismKey = 'PrismKey',
    CloudSeed = 'CloudSeed',
    CelestialRose = 'CelestialRose',
    Yat = 'Yat',
}

export interface LootBoxMetadataResponse {
    animation_url: string;
    external_link: string;
    attributes: string[];
    owner_name?: string;
    description: string;
    icon_url: string;
    token_id: string;
    image: string;
    name: string;
}

export interface ArtifactMetaDataResponse {
    main_id: string;
    artifact_type: ArtifactType;
    metadata: LootBoxMetadataResponse;
}
